// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__22JsH","productName":"Table_productName__6N17J"};